// src/game/story/registry.js
// CRA (react-scripts) supports require.context. This auto-loads storylets.
// Drop new storylets into storylets/ and they'll be picked up automatically.

import { checkReqs } from './effects';

function loadAllStorylets() {
  // js files only for now (you can add .json later if you want)
  const req = require.context('./storylets', false, /\.(js)$/);

  const list = req
    .keys()
    .map((k) => {
      const mod = req(k);
      return mod?.default || mod;
    })
    .filter(Boolean);

  // Guard: ensure each has an id
  return list.filter((s) => s && typeof s.id === 'string' && s.id.length > 0);
}

export const STORYLETS = loadAllStorylets();

export function getStoryletById(id) {
  const want = String(id || '');
  return STORYLETS.find((s) => s.id === want) || null;
}

export function getEligibleStorylets(flags, resources, meta) {
  return STORYLETS.filter((s) => checkReqs(s.requirements, { flags, resources, meta }));
}
